export default "__VITE_ASSET__COztzEty__"